import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d0a49ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 1,
  class: "loader"
}

import { IonSpinner } from '@ionic/vue'
interface Props {
  light?: boolean
  loading?: boolean
  green?: boolean
}


const __default__ = {
  name: 'VBtn'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    light: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    green: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _mergeProps(_ctx.$attrs, {
    class: ["v-btn", { light: __props.light, green: __props.green }],
    disabled: __props.loading
  }), [
    (!__props.loading)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 })
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(IonSpinner), {
            class: _normalizeClass({ light: __props.light }),
            name: "crescent"
          }, null, 8, ["class"])
        ]))
  ], 16, _hoisted_1))
}
}

})